import { render, staticRenderFns } from "./structureModel.vue?vue&type=template&id=264b77cc"
import script from "./structureModel.vue?vue&type=script&lang=js"
export * from "./structureModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('264b77cc')) {
      api.createRecord('264b77cc', component.options)
    } else {
      api.reload('264b77cc', component.options)
    }
    module.hot.accept("./structureModel.vue?vue&type=template&id=264b77cc", function () {
      api.rerender('264b77cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/accountManage/structureModel.vue"
export default component.exports